export const foodReservationDetailsTemplate = `
<div style="margin: 0; padding-top: 10px; padding-bottom: 10px">
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333; padding-top: 10px">
        <strong>Deine Auswahl</strong>
    </p>
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{booking}}</p>
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{bookingRoom}}</p>
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{customerAmount}} {{customerAmountDescription}}</p>
</div>
<div style="padding-top: 10px; padding-bottom: 10px">
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333; padding-top: 10px">
        <strong>Wo<br /></strong>
    </p>
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{tenantAddress}}</p>
</div>`
